/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Facts_Source_ValueInputs */

const en_gc_resources_facts_source_value = /** @type {(inputs: Gc_Resources_Facts_Source_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open source`)
};

const zh_gc_resources_facts_source_value = /** @type {(inputs: Gc_Resources_Facts_Source_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源`)
};

/**
* | output |
* | --- |
* | "Open source" |
*
* @param {Gc_Resources_Facts_Source_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_facts_source_value = /** @type {((inputs?: Gc_Resources_Facts_Source_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Facts_Source_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_facts_source_value(inputs)
	return zh_gc_resources_facts_source_value(inputs)
});
export { gc_resources_facts_source_value as "gc.resources.facts.source.value" }